// Shared helpers for authenticated CSV downloads (OC history, briefing report).
// The backend sends the filename via Content-Disposition, so downloads happen
// through fetch + blob instead of a plain <a href>.

/** Pulls the filename out of `Content-Disposition: attachment; filename="..."`. */
export const parseCsvFilename = (
  header: string | null,
  fallback: string
): string => {
  if (!header) return fallback;
  // Prefer RFC 5987 filename* if present, then plain filename.
  const utf8Match = header.match(/filename\*=(?:UTF-8'')?["']?([^"';]+)["']?/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      return utf8Match[1];
    }
  }
  const match = header.match(/filename=["']?([^"';]+)["']?/i);
  return match?.[1] || fallback;
};

/** Saves a blob to disk through a temporary object URL + anchor click. */
export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
};
